import { NormalizedHistory } from './history'
import { ServerTask } from './tasks'
import { ServerProject } from './projects'
import { CurrentUser, User } from './users'
import { ProjectWorkObject } from './objects'
import { Comment } from './comments'
import { Tag } from './tags'
import { Bool, ID } from '../types/UtilityTypes'

export interface Event<T = unknown> {
    action: 'add' | 'update' | 'delete',
    type: string,
    comment: null,
    model: T,
    socket: null,
}

export interface EventFrame {
    event: Event,
}

export interface HistoryFrame {
    history: NormalizedHistory,
}

export interface UserFrame {
    user: CurrentUser,
    reload: boolean,
}

export interface UserInfoFrame {
    users: User[],
}

export interface UnreadData {
    id: number,
    type: 'project_work_object' | 'task';
    unread_history: number,
}

export type UnreadFrame = {
    data: UnreadData[],
    history: {
        id: ID,
        read: Bool,
    }
}

export type UpdateFrame = {
    update_at: string,
}

export const isTaskEvent = (event: Event): event is Event<ServerTask> => event.type === 'task'
export const isProjectEvent = (event: Event): event is Event<ServerProject> => event.type === 'project'
export const isObjectEvent = (event: Event): event is Event<ProjectWorkObject & { tags?: Tag[] }> => event.type === 'project_work_object'
export const isCommentEvent = (event: Event): event is Event<Comment> => event.type === 'comment'